import { DialogMessageViewModel } from '@common/model/dialog/message/dialogMessageViewModel';
import { isMessageAuthor } from '../lib';
import { useCurrentDialogMember } from './useCurrentDialogMember';

export const useIsOutgoing = (message: DialogMessageViewModel): boolean => {
  const currentMember = useCurrentDialogMember();
  return isMessageAuthor(message, currentMember);
};
